import PropTypes from 'prop-types';
import React from 'react';
import './multimedia.css';
import { getIdVimeo } from './getIdVimeo';
import { getIdYoutube } from './getIdYoutube';
import imageTour from 'assets/img/logos/360-tour.png';

export const EmbedVideo = ({ src, show, setShow }) => {
  const isYoutube = src.includes('youtube') || src.includes('youtu.be');
  const is360 =
    /(www.recorrido360.com.ar\/recorridos\/)/.test(src) ||
    /(kuula.co\/)/.test(src) ||
    /(klapty.com\/tour\/)/.test(src);
  return (
    <div className="w-100 mt-2 p-1 border" style={{ aspectRatio: '16/9' }}>
      <video-embed>
        {!show ? (
          <>
            {isYoutube ? (
              <img
                loading="lazy"
                src={`https://i.ytimg.com/vi/${getIdYoutube(
                  src
                )}/hqdefault.jpg`}
                alt="Video Description"
              />
            ) : is360 ? (
              <img
                loading="lazy"
                alt="Video Description"
                src={imageTour}
                style={{
                  objectFit: 'contain'
                }}
              />
            ) : (
              <img
                loading="lazy"
                src={`https://vumbnail.com/${getIdVimeo(src)}.jpg`}
                alt="Video Description"
              />
            )}
            <button
              aria-label="Play video"
              className="embbed-video-button"
              style={{
                backgroundColor: isYoutube ? '#f00' : is360 ? '#000' : '#00adef'
              }}
              onClick={e => {
                e.preventDefault();
                setShow(true);
              }}
            />
          </>
        ) : (
          <iframe
            width="100%"
            height="100%"
            src={
              isYoutube
                ? `//www.youtube.com/embed/${getIdYoutube(src)}`
                : is360
                ? src
                : `//player.vimeo.com/video/${getIdVimeo(src)}`
            }
            title={
              isYoutube ? 'Reproductor de Youtube' : 'Reproductor de Vimeo'
            }
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
          />
        )}
      </video-embed>
    </div>
  );
};

EmbedVideo.propTypes = {
  src: PropTypes.string.isRequired,
  show: PropTypes.bool.isRequired,
  setShow: PropTypes.func.isRequired
};
